"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJfZGVmYXVsdCIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9saWJyYXJ5L3NyYy9jbGllbnQvbW9kdWxlcy9Db250ZW50L01lbnUvTWVudVJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7XHJcblxyXG59XHJcblxyXG5leHBvcnQgZGVmYXVsdCByb3V0ZXM7Il0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxNQUFNLEdBQUcsQ0FFZixDQUFDO0FBQUEsSUFBQUMsUUFBQSxHQUFBQyxPQUFBLGNBRWNGLE1BQU0ifQ==